import React from 'react';
import { ComponentWithChildren } from '../models/ComponentWithChildren';
import style from './liberis.scss';

const IframeLayout = ({ children }: ComponentWithChildren): JSX.Element => (
  <div className={style.container}>{children}</div>
);

export default IframeLayout;
